import mapStyleDefaultJson from '@assets/map/map_style.json';
import mapStyleSAJson from '@/assets/map/map_style_sa.json';
import { isLogicFollowSA } from '.';

const SLCommon = Mach.requireModule('SLCommon');
const Raptor = Mach.requireModule('Raptor');
const SLCompass = Mach.requireModule('SLCompass');

const hasGooglePlayService = Mach.env.isIOS ? true : SLCommon.checkGooglePlayServices();

// 地图监控
const mapPageName = {
  addressSelector: 'address_selector', // 地址选择
  shopDetail: 'shop_detail', // 店铺详情
  shopMap: 'shop_map', // 店铺地图页
  orderStatus: 'order_status', // 订单状态
  im: 'im', // im页面
  orderMap: 'orderMap',
  orderMapGolden: 'order_map_golden',
  pickUpAddress: 'pickUpAddress',
  pickUpMap: 'pickUpMap',
  addressSelectorPopup: 'address_selector_popup', // 首页地址浮层
};

const getMapType = () => {
  let mapType = '8';
  if (!hasGooglePlayService) {
    mapType = '3';
  }

  return mapType;
};

const defaultTags = {
  container: 'Mach Pro',
  mapType: getMapType(),
  osName: Mach.env.osName ?? '',
  osVersion: Mach.env.osVersion ?? '',
  appVersion: Mach.env.version ?? '',
  platform: Mach.env.isAndroid ? 'Android' : 'iOS',
};

export { hasGooglePlayService, mapPageName };

// 地图打开次数
export const reportMapLoadCount = (page?: string) => {
  const tags = { ...defaultTags, ...{ page } || {} };
  Raptor?.reportMetrics({ mapLoadCount: 1 }, tags, 1);
};

// 地图加载完成次数
export const reportMapLoadSuccessCount = (page?: string) => {
  const tags = { ...defaultTags, ...{ page } || {} };
  Raptor?.reportMetrics({ mapLoadSuccessCount: 1 }, tags, 1);
};

// 地图加载时长
export const reportMapLoadedTime = (duration: any, page?: string) => {
  const tags = { ...defaultTags, ...{ page } || {} };
  Raptor?.reportMetrics({ mapLoadedTime: duration }, tags, 1);
};

// 地图自定义样式
export const styleOptions = () => {
  let styleJson = mapStyleDefaultJson;
  const { region } = SLCompass?.getCompassInfo?.() || {};
  if (isLogicFollowSA(region)) {
    // @ts-ignore
    styleJson = mapStyleSAJson;
  }

  return {
    styleJson,
    styleName: 'Scolor_Sicon_haiwai_1',
    styleURL: 'sankuai://tile/style?id=Scolor_Sicon_haiwai_1.json'
  };
};
